import { globalTheme } from "../../styles";

export const PickAndPackIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px" } = props;

  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      fill={globalTheme.primaryColor}
      viewBox="0 0 612 612"
    >
      <g>
        <path
          d="M524.545,64.853c-6.943-8.71-17.476-13.784-28.614-13.784H116.068c-11.138,0-21.67,5.073-28.612,13.784L13.96,157.059
		C6.282,166.691,0,184.652,0,196.97v318.223c0,25.261,20.478,45.738,45.738,45.738h520.524c25.261,0,45.738-20.478,45.738-45.738
		V196.97c0-12.319-6.282-30.279-13.96-39.912L524.545,64.853z M480.518,370.876c-5.646,0-9.175-6.112-6.352-11.003l28.434-49.247
		c2.823-4.89,9.881-4.89,12.704-0.001l28.439,49.248c2.823,4.89-0.706,11.003-6.353,11.003h-11.934v91.799
		c0,4.052-3.284,7.335-7.335,7.335h-18.337c-4.052,0-7.335-3.283-7.335-7.335v-91.799H480.518z M370.491,370.876
		c-5.646,0-9.176-6.112-6.352-11.003l28.433-49.247c2.823-4.89,9.881-4.89,12.704-0.001l28.438,49.248
		c2.825,4.89-0.705,11.003-6.352,11.003h-11.933v91.799c0,4.052-3.284,7.335-7.335,7.335h-18.337c-4.052,0-7.335-3.283-7.335-7.335
		v-91.799H370.491z M557.661,511.458c0,2.025-1.642,3.668-3.667,3.668H351.613c-2.025,0-3.668-1.643-3.668-3.668v-11.002
		c0-2.025,1.643-3.668,3.668-3.668h202.38c2.025,0,3.667,1.642,3.667,3.668L557.661,511.458L557.661,511.458z M62.317,125.743
		h166.061l16.387-26.943H83.793l17.969-22.544c3.491-4.38,8.706-6.892,14.306-6.892h379.863c5.602,0,10.815,2.512,14.308,6.892
		l17.969,22.544h-163.84l9.147,26.943h176.167l24.339,30.536H37.979L62.317,125.743z"
        />
      </g>
    </svg>
  );
};
